<template>
  <v-dialog :model-value="modelValue" max-width="680" persistent @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon left>mdi-playlist-play</v-icon>
        {{ batchDeviceCount > 0 ? '批量组合表情测试' : '组合动作执行' }}
        <v-spacer />
        <span class="text-body-2 text-grey">
          <template v-if="batchDeviceCount > 0">{{ batchDeviceCount }} 台设备 × {{ loopCount }} 轮 · </template>
          共 {{ items.length }} 个动作
        </span>
      </v-card-title>
      <v-divider />
      <v-card-text style="max-height: 60vh; overflow-y: auto;">
        <div class="d-flex align-center mb-2">
          <v-switch
            :model-value="uniform"
            label="整组统一间隔"
            color="primary"
            density="compact"
            hide-details
            inset
            @update:model-value="$emit('update:uniform', $event)"
          />
          <v-text-field
            v-if="uniform"
            :model-value="globalInterval"
            label="间隔时间 (ms)"
            type="number"
            min="0"
            density="compact"
            variant="outlined"
            hide-details
            style="max-width: 180px; margin-left: 16px;"
            @update:model-value="$emit('update:globalInterval', Number($event))"
          />
          <v-spacer />
        </div>
        <div class="text-caption text-grey mb-3">
          按从上到下的顺序依次执行；每个动作播放结束后，再等待对应的间隔时间执行下一个。
        </div>
        <v-alert v-if="batchDeviceCount > 0" type="info" variant="tonal" density="compact" class="mb-3">
          每个动作将同时下发至 {{ batchDeviceCount }} 台设备，整组组合表情循环 {{ loopCount }} 次。
        </v-alert>
        <v-list density="compact" class="py-0">
          <v-list-item
            v-for="(item, idx) in items"
            :key="item.id"
            class="px-1"
          >
            <template v-slot:prepend>
              <div class="d-flex flex-column mr-1">
                <v-btn icon size="x-small" variant="text" :disabled="idx === 0" @click="$emit('move-item', idx, -1)">
                  <v-icon>mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn icon size="x-small" variant="text" :disabled="idx === items.length - 1" @click="$emit('move-item', idx, 1)">
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
              <v-chip size="small" class="mr-2" color="deep-purple" variant="flat">{{ idx + 1 }}</v-chip>
            </template>
            <v-list-item-title>
              {{ item.operationName }}
              <span v-if="item.emoji" class="ml-1">{{ item.emoji }}</span>
            </v-list-item-title>
            <v-list-item-subtitle>
              时长 ≈ {{ item.durationMs }} ms
              <span v-if="!item.hasMotion" class="text-red"> · 无动作数据，将跳过</span>
            </v-list-item-subtitle>
            <template v-slot:append>
              <v-text-field
                v-if="!uniform && idx < items.length - 1"
                v-model.number="item.interval"
                label="间隔(ms)"
                type="number"
                min="0"
                density="compact"
                variant="outlined"
                hide-details
                style="width: 120px;"
                class="mr-2"
              />
              <v-btn icon size="small" variant="text" color="red" @click="$emit('remove-item', idx)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-3">
        <v-btn variant="outlined" @click="$emit('update:modelValue', false)">取消</v-btn>
        <v-spacer />
        <v-btn
          color="deep-purple"
          variant="outlined"
          :disabled="items.filter(it => it.hasMotion).length < 2"
          @click="$emit('combine')"
        >
          <v-icon left>mdi-vector-combine</v-icon>合成为操作记录
        </v-btn>
        <v-btn color="primary" variant="flat" :disabled="items.length === 0" @click="$emit('start')">
          <v-icon left>mdi-play</v-icon>{{ batchDeviceCount > 0 ? '开始批量测试' : '开始执行' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
defineProps({
  modelValue: { type: Boolean, default: false },
  items: { type: Array, default: () => [] },
  uniform: { type: Boolean, default: true },
  globalInterval: { type: Number, default: 1000 },
  batchDeviceCount: { type: Number, default: 0 },
  loopCount: { type: Number, default: 1 }
})
defineEmits(['update:modelValue', 'update:uniform', 'update:globalInterval', 'move-item', 'remove-item', 'combine', 'start'])
</script>
